import { IEquipmentModel } from '../../equipmentModels.types.ts'
import SidePage from '@/shared/SidePage'
import { useState } from 'react'
import ViewEquipmentModelSidePageContent from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelSidePage/ViewEquipmentModelSidePageContent'
import EditEquipmentModelSidePageContent from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelSidePage/EditEquipmentModelSidePageContent'

interface IProps {
  open: boolean
  id: IEquipmentModel['id']
  onClose: () => void
}

const EquipmentModelSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'view') {
      return (
        <ViewEquipmentModelSidePageContent
          modelId={props.id}
          onEdit={() => setPageMode('edit')}
          onClose={props.onClose}
        />
      )
    }

    return <EditEquipmentModelSidePageContent modelId={props.id} onCancel={() => setPageMode('view')} />
  }

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.id) return null

  return <EquipmentModelSidePage {...props} />
}
